import React from "react";
import { Row as FlexRow } from "jsxstyle";

const Row = (props) => <FlexRow {...props} flexDirection="row" boxSizing="border-box" />;

export default Row;
